import React from 'react'
import { Outlet } from 'react-router-dom';
import TopNav from './Navbar/TopNav';
import Scroller from './ScrollTop/Scroller' 
import Footer from './Footer/Footer';

function Layout() {
    return (
        <>
            <TopNav />
            <Outlet />
            <Scroller />
            <Footer />
        </>
    )
}

export default Layout;